module.exports = __webpack_public_path__ + "img/more.20084bc7.svg";